<div *ngIf="active" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>